'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _form = require('../lib/form');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _inputValidations = require('../input-validations');

var _inputValidations2 = _interopRequireDefault(_inputValidations);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var InputField = function InputField(_ref) {
  var classNames = _ref.classNames,
      error = _ref.error,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      required = _ref.required,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'text' : _ref$type,
      _onBlur = _ref.onBlur,
      _onChange = _ref.onChange,
      _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      status = _ref.status,
      validations = _ref.validations,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ['classNames', 'error', 'id', 'label', 'name', 'required', 'type', 'onBlur', 'onChange', 'styles', 'status', 'validations', 'value']);

  var propsBlacklist = ['children', 'dirty', 'initial', 'invalid', 'styles', 'touched', 'validators'];
  var allowedProps = (0, _omit2.default)(props, propsBlacklist);
  var Tag = type === 'textarea' ? 'textarea' : 'input';
  var inputId = id || name;
  var labelId = 'label-' + inputId;

  var renderField = function renderField() {
    return _react2.default.createElement(Tag, _extends({
      className: classNames.field,
      type: type,
      name: name,
      id: inputId,
      value: value,
      checked: (0, _form.isBoolean)(type) && value,
      onChange: function onChange(e) {
        return _onChange && _onChange((0, _form.isBoolean)(type) ? e.target.checked : e.target.value);
      },
      onBlur: function onBlur(e) {
        return _onBlur && _onBlur((0, _form.isBoolean)(type) ? e.target.checked : e.target.value);
      },
      required: required,
      'aria-labelledby': labelId
    }, allowedProps));
  };

  var renderStatus = function renderStatus() {
    switch (status) {
      case 'fetching':
        return _react2.default.createElement(_icon2.default, { styles: styles.status, name: 'loading', spin: true, color: 'grey' });
      case 'fetched':
        return _react2.default.createElement(_icon2.default, { styles: styles.status, name: 'check', color: 'success' });
      case 'failed':
        return _react2.default.createElement(_icon2.default, { styles: styles.status, name: 'warning', color: 'danger' });
      default:
        return null;
    }
  };

  return _react2.default.createElement(
    'div',
    { className: 'c11n-input-field ' + classNames.root },
    label && _react2.default.createElement(
      _label2.default,
      {
        id: labelId,
        inputId: inputId,
        required: required,
        styles: {
          root: styles.label,
          required: styles.required
        }
      },
      label
    ),
    renderField(),
    status && renderStatus(),
    error && _react2.default.createElement(_inputValidations2.default, {
      styles: { root: styles.error },
      validations: validations
    })
  );
};

InputField.propTypes = {
  /**
   * The label for the field
   */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),

  /**
   * Whether to display validation errors
   */
  error: _propTypes2.default.bool,

  /**
   * The name of the field
   */
  name: _propTypes2.default.string.isRequired,

  /**
   * The current value
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string]),

  /**
   * The change handler that will receive the updated value as it's only param
   */
  onChange: _propTypes2.default.func.isRequired,

  /**
   * The blur handler that will receive the updated value as it's only param
   */
  onBlur: _propTypes2.default.func,

  /**
   * The type of field
   */
  type: _propTypes2.default.oneOf(['checkbox', 'color', 'date', 'email', 'hidden', 'month', 'number', 'password', 'radio', 'range', 'search', 'tel', 'text', 'textarea', 'time', 'url', 'week']),

  /**
   * The placeholder for the field
   */
  placeholder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * The ID for the field
   */
  id: _propTypes2.default.string,

  /**
   * Mark the field as required and displays an asterisk next to the label
   */
  required: _propTypes2.default.bool,

  /**
   * Validation errors
   */
  validations: _propTypes2.default.array,

  styles: _propTypes2.default.object
};

InputField.defaultProps = {
  type: 'text'
};

exports.default = (0, _withStyles2.default)(_styles2.default)(InputField);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/input-field/index.js
// module id = 67
// module chunks = 0